import { isNumber } from 'lodash-es';

import { ICena, IInneTerminy } from '../../../types/IBloczek';

export type TPropName = 'promocja' | 'aktualna';

export const formatPrice = (price: number) => {
  if (!isNumber(price)) return '';

  const val = (price / 1).toFixed(2).replace('.', ',').replace(',00', '');

  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

export const checkPrice = (price: number) => (price !== 0 ? `+${formatPrice(price)}` : formatPrice(price));
// Todo: error
// eslint-disable-next-line @typescript-eslint/no-shadow
const composeShowCena = (formatPrice: (cena: number) => string) => (propName: TPropName, cena: ICena | IInneTerminy) => formatPrice(propName === 'promocja' ? cena.CenaPrzedPromocja : cena.CenaAktualna);

export const showCena = composeShowCena(formatPrice);
